<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><a id="file_034"><strong>2.</strong> Twist a small piece of yellow wool between your fingertips. Lay the stripe around the middle of the bumblebee and needle to attach. Needle two more stripes onto the body, one in front and one behind the middle stripe.</a></p><a id="file_034">
<p class="image"><img alt="Image" src="images/f0014-02.jpg"/></p>
<p class="image"><img alt="Image" src="images/f0014-03.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_034.vue?06f08e70